import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getNumOfCommentedReviews } from '../../../modules/ReviewsModule';

@connect((state) => ({ numOfCommentedReviews: state.reviewsModule.numOfCommentedReviews }), { getNumOfCommentedReviews })
export default class ReviewsHeader extends Component {
  componentDidMount = () => {
    this.props.getNumOfCommentedReviews();
  };

  render() {
    return (
      <div className="reviews-header l-flex-vcenter-spaced-screen-sm">
        <div className="resource-reviews">
          <div className="title">Your resource reviews</div>
          <div className="review-text">
            <span className="text">You have reviewed</span>
            <span className="number"> {this.props.numOfCommentedReviews} </span>
            <span className="text">resources</span>
          </div>
        </div>
      </div>
    );
  }
}

ReviewsHeader.propTypes = {
  getNumOfCommentedReviews: PropTypes.func,
  numOfCommentedReviews: PropTypes.number,
};
